// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3104 ? "3975359d" : chunkId) + "." + {"165":"e339ae7fe8eb510e","472":"424b289187625c19","1080":"d7623da947cc9234","3104":"39bcf6269074b683","9341":"89e743dc7050edf7"}[chunkId] + ".js";
};